import { combineReducers } from "redux";
import userReducer, { IUserState } from "./users/userReducer";

export interface IRootState {
  user: IUserState;
}

const rootReducer = combineReducers({
  user: userReducer,
});

export default rootReducer;
